export default {
sets: `Imposta`,
stats: `Statistiche`,
discover: `Scoprire`,
guides: `Guide`,
settings: `Impostazioni`,
unsupportedBrowserBody: `FlashCards non supporta questo browser. Scarica l'ultima versione di Chrome o Opera o scarica il nostro iPhone o l'applicazione Android`,
unsupportedBrowserTitle: `Browser non supportato`,
noData: `Nessun dato da mostrare`,
contactUsTitle: `Adoriamo sentire come i nostri utenti usano la nostra app e come possiamo migliorare. Lasciaci un messaggio con qualsiasi domanda, come richieste di funzionalità o report di bug`,
rateAppStore: `Tasso in Appstore`,
rateGoogle: `Valuta in Google Play`,
close: `Chiudere`,
shareFriends: `Condividere con gli amici`,
noCardsQ: `Non hai flashcard?`,
noCardsS: `Scegli dalla nostra collezione per iniziare`,
suggestSet: `Suggerire set`,
createOwn: `Crea il tuo`,
search: `Ricerca`,
loading: `Caricamento in corso`,
words: `Parole`,
downloads: `Download`,
export: `Esportare`,
import: `Importare`,
importing: `Importazione ... non chiudere l'app`,
importPreview: `Anteprima delle importazioni`,
howQuizlet: `Come importare da Quizlet`,
cards: `Carte`,
importPreviewStatus: `__ I termini sono pronti per essere aggiunti alle carte ___ esistenti`,
importPaste: `Incolla le tue carte in textrea di cui sopra`,
setTotalLimitReached: `Puoi avere solo 3000 carte in uno studio`,
studying: `Studiando`,
learnt: `Imparato`,
mastered: `Padroneggiato`,
new: `Nuovo`,
noTerm: `Nessun termine`,
noDef: `Nessuna definizione`,
cardSaved: `Carta salvata`,
reviews: `Recensioni`,
practices: `Pratiche`,
flashcards: `Flashcard`,
alerts: `Avvisi`,
corrects: `Corregge`,
mistakes: `Errori`,
reviewCycle: `Ciclo di revisione`,
reviewsLeft: `Recensioni rimaste`,
lastReview: `Ultima recensione`,
nextReview: `Next Review`,
hideHistory: `Nascondi la storia completa`,
showHistory: `Mostra la storia completa`,
strength: `Forza`,
star: `Stella`,
image: `Immagine`,
tag: `Etichetta`,
added: `aggiunto`,
removed: `RIMOSSO`,
reviewedFrom: `Recensione da __`,
notifications: `Notifiche`,
reviewedPractice: `Recensione __ da ___ pratica`,
successfully: `con successo`,
unsuccessfully: `senza successo`,
termUpdated: `Termine aggiornato`,
defUpdated: `Definizione aggiornata`,
flashcardCreated: `Flashcard creato`,
dropboxImage: `È necessario abilitare la sincronizzazione di Dropbox per aggiungere immagini`,
deleteImgConfirm: `Sei sicuro di voler eliminare questa immagine?`,
uploading: `Caricamento`,
save: `Salva`,
uploadImageFail: `Impossibile caricare l'immagine`,
imageUploaded: `Immagine caricata`,
setNotFound: `Studio non trovato!`,
notEnoughCards: `Non abbastanza carte!`,
of: `__ di ___`,
on: `SU`,
off: `Spento`,
auto: `Automatico`,
manual: `Manuale`,
pronounce: `Pronunciare`,
practiceCompleted: `Hai completato questa pratica`,
closePractice: `Stretta pratica`,
autoplay: `Riproduzione automatica`,
secFlipSecNext: `__ Sec Flip, ___ Sec Next`,
autopronounce: `Autopronune`,
onlyTerm: `Solo termine`,
onlyDef: `Solo definizione`,
termAndDef: `Termine e definizione`,
savePractice: `Salvare la pratica?`,
continueLater: `Continua più tardi`,
deletePractice: `Elimina la pratica`,
term: `Termine`,
def: `Definizione`,
monA: `M`,
tueA: `T`,
wedA: `W`,
thuA: `T`,
friA: `F`,
satA: `S`,
sunA: `S`,
reviewGoal: `Obiettivo di revisione`,
dailyGoal: `Obiettivo quotidiano`,
edit: `Modificare`,
setUp: `Impostare`,
noRecentPractice: `Non hai pratiche recenti`,
continueLastReview: `Continua l'ultima revisione`,
dueCards: `Carte dovute`,
studyNow: `Studia ora`,
newCards: `Nuove carte`,
terms: `termini`,
defs: `Definizioni`,
validCardsOf: `È possibile praticare solo __ delle carte ___ selezionate, poiché gli altri mancano il termine o la definizione`,
reviewCards: `Carte di recensione`,
customizePractice: `Personalizza la pratica`,
next: `Prossimo`,
iWasRight: `avevo ragione`,
printProAlert: `Acquista l'abbonamento Pro per stampare più di 20 flashcard`,
print: `Stampa`,
printWidth: `Larghezza del termine-def`,
printFont: `Dimensione del font`,
printBorder: `Frontiera`,
printMargin: `Margine di pagina`,
printPadding: `Imbottitura delle parole`,
preparingFile: `Preparazione del file`,
notificationsBlocked: `Le notifiche non sono abilitate, si abilitano le notifiche dalle impostazioni del telefono`,
ranOutOfWords: `Ho esaurito le carte, riavviare la pratica per ricominciare`,
ranOutOfWordsShort: `Fugli le parole`,
ranOutOfWordsBody: `Apri l'app per programmare nuove parole`,
proIncreaseNotifications: `Puoi aumentare le notifiche totali da 10 a 50 nella versione premium.`,
schedule: `Programma`,
frequency: `Frequenza`,
mode: `Modalità`,
tM1: `1 minuto`,
tM2: `2 minuti`,
tM5: `Cinque minuti`,
tM10: `10 minuti`,
tM15: `15 minuti`,
tM30: `30 minuti`,
tH1: `1 ora`,
tH2: `2 ore`,
termPassive: `Termine passivo`,
termActive: `Termine attivo`,
defPassive: `Definive`,
defActive: `Def attivo`,
scheduledIn: `Programmato in __ minuti`,
scheduledAlertsProT: `Aumenta gli avvisi programmabili con Pro`,
scheduledAlertsProB: `È possibile aumentare gli avvisi programmati da 10 a 50 con il pacchetto Pro`,
seeFeatures: `Vedi funzionalità`,
defAndTerm: `Definizione e termine`,
termHoldDef: `Termine, tenere per rivelare la definizione`,
defHoldTerm: `Definizione, tenere per rivelare il termine`,
notificationType: `Tipo di notifica`,
copyToClipboard: `Copia negli appunti`,
enterAuthCode: `Inserisci il tuo codice di autorizzazione`,
invalidCode: `Codice non valido fornito`,
copied: `Copiato!`,
promoH2: `FlashCard Manager Pro`,
promoP: `Tocca per scoprire tutte le funzionalità premium per imparare in modo più efficiente nel tuo ritmo`,
promoBtn: `Scopri tutte le funzionalità`,
setDropboxH2: `Dropbox Sync`,
setDropboxPOff: `Abilita Dropbox Sync per mantenere set, flashcard, tag e progressi eseguiti il ​​backup e l'aggiornamento su tutti i dispositivi.`,
setDropboxPOn: `I tuoi dati sono backup e sincronizzati su tutti i dispositivi.`,
setDropboxBtn: `Sincronizzazione`,
status: `Stato`,
syncNow: `Sincronizza ora`,
contact: `Contatto`,
contactUs: `Contattaci`,
useFromBrowser: `Utilizzare dal browser`,
useFromBrowserMsg: `Visita FlashCardsMadeSimple.com sul tuo computer e ripristina le tue carte e la licenza abilitando Dropbox Sync`,
termsPrivacy: `Termini e privacy`,
dailyReviewGoal: `Obiettivo di revisione quotidiana`,
numberTerms: `Numero di termini`,
selectTerm: `Seleziona con il suggerimento del termine`,
selectDef: `Seleziona con il suggerimento di definizione`,
pronounceTerm: `Pronuncia con il suggerimento del termine`,
pronounceDef: `Pronuncia con il suggerimento di definizione`,
typeTerm: `Digita con il suggerimento del termine`,
typeDef: `Digita il suggerimento di definizione`,
quizTypes: `Tipi di quiz preferiti`,
spacedRepetition: `Programma di ripetizione distanziata`,
spacedRepetitionP: `La ripetizione distanziata consente di padroneggiare le parole con meno sforzi spaziando in modo incrementale il tempo di revisione. Il programma predefinito è 1-3-7-15-31 giorni, ma puoi configurarne anche uno personalizzato.`,
spacedRepetionScheduleItem: `__ giorni dopo ___ recensione (giorno ____)`,
atLeastOneSchedule: `È richiesto almeno un programma`,
revisionLimitReached: `Hai raggiunto il massimo conteggio di Revsision`,
addReviewSchedule: `Aggiungi un nuovo programma di revisione`,
autoMarkLearnt: `L'auto Mark ha appreso dopo`,
autoMarkMastered: `Mark automatico padroneggiato dopo`,
tagManager: `Tag manager`,
delete: `Eliminare`,
addTag: `Aggiungi nuovo tag`,
tagDeletionH: `Eliminazione dei tag`,
tagDeletionP: `Sei sicuro di voler eliminare questo tag?`,
cancel: `Annulla`,
daysAfterLastReview: `Giorni dopo l'ultima recensione`,
linkDropbox: `Link Dropbox`,
startSync: `Inizia la sincronizzazione`,
starred: `Ha recitato`,
images: `immagini`,
tags: `Tag`,
types: `Tipi`,
activeDays: `Giorni attivi`,
inactiveDays: `Giorni inattivi`,
longestStreak: `Striscia più lunga`,
dailyGoalsCompleted: `Obiettivi giornalieri completati`,
dailyGoalsFailed: `Gli obiettivi quotidiani sono falliti`,
typePairs: `Tipi coppie`,
reviewTypes: `Tipi di revisione`,
typePractice: `Digitare la pratica`,
pronouncePractice: `PRONEGGIO PRATICHE`,
selectPractice: `Seleziona la pratica`,
notificationReview: `Revisione della notifica`,
flashcardReview: `Recensione flashcard`,
studyset: `Studio`,
enterStudysetName: `Inserisci un nome per il tuo studio`,
studysetName: `Immettere il nome del set`,
termType: `Tipo di termine / lang`,
defType: `Tipo di definizione / lang`,
exportCards: `Carte di esportazione`,
importCards: `Carte di importazione`,
quiz: `Quiz`,
showingOutOfCards: `Mostrando __ su ___ carte`,
showingAllCards: `Mostrare tutte le schede, digitare nella barra di ricerca sopra o toccare eventuali tag da filtrare`,
recording: `Registrazione`,
downloadSet: `Aggiungi ai miei set`,
addNewCard: `Aggiungi nuova carta`,
saveStudyset: `Salva set di studio`,
studysetDeletionH: `Eliminazione dello studio`,
studysetDeletionP: `Sei sicuro di voler eliminare questo studio, questo eliminerà anche tutte le carte contenute.`,
cardDeletionH: `Eliminazione della carta`,
cardDeletionP: `Sei sicuro di voler eliminare questa carta`,
cardLimitReached: `Puoi avere solo 3000 carte in uno studio`,
limitExceeded: `Limite superato`,
atLeastTenCards: `Aggiungi almeno 10 carte per iniziare con le pratiche`,
searchInAll: `Cerca in tutti i set di studi`,
noMatch: `Nessuna corrispondenza`,
atLeastThreeChars: `Immettere almeno 3 caratteri per cercare`,
noSets: `Nessun set`,
startingSync: `Sincronizzazione iniziale`,
noSetsP: `Seleziona tra le opzioni seguenti per iniziare`,
startingSyncP: `Stiamo ottenendo i tuoi dati da Dropbox, potrebbe richiedere del tempo`,
createNewStudyset: `Crea un nuovo studio`,
restoreFromBackup: `Ripristina dal file di backup`,
setStarterPacks: `Starterpack StudySet`,
selectPracticeType: `Seleziona il tipo di pratica`,
noDueCards: `Nessuna dovuta flashcard, flashcard che hai esaminato in precedenza inizieranno a presentarsi qui dopo il programma di ripetizione distanziata selezionata per aiutarti a padroneggiare le parole con meno sforzo e tempo`,
noNewCards: `Nessuna nuova carta da studiare`,
subscriptionH: `Acquista Pro per godere di tutte le funzionalità e per supportare lo sviluppo continuo.`,
buyLifetimePro: `Acquista Lifetime Pro per __`,
restorePurchase: `RIPRISTINARE ACQUISTO`,
termsPrivacyC: `Termini e politica sulla privacy`,
licenceShare: `Se hai acquistato una licenza da un altro dispositivo, è possibile condividerla con questo dispositivo abilitando la sincronizzazione di Dropbox su entrambi i dispositivi`,
enterTagName: `Immettere il nome del tag`,
invalidName: `Nome non valido`,
create: `Creare`,
name: `Nome`,
tagName: `Nome del tuo tag`,
color: `Colore`,
back: `Di ritorno`,
rowSeparator: `Separatore di righe`,
termDefSeparator: `Termine - DEF Separator`,
output: `Produzione`,
inputCards: `Carte di input`,
review: `Revisione`,
language: `Lingua`,
archiveReversible: `Archivio (reversibile dalle impostazioni)`,
deletePermanent: `Elimina (irreversibile)`,
archivedCards: `Carte archiviate`,
masteredCards: `Carte master`,
due: `Dovuto`,
reviewed: `Rivisto`,
markReviewed: `Mark Review`,
markMastered: `Mark padroneggiato`,
forXYCards: `per __ ___ carte`,
createdAtSortBy: `Data di creazione`,
lastReviewedSortBy: `Ultima data di revisione`,
reviewCountSortBy: `Numero di recensioni`,
strengthSortBy: `Forza`,
termSortBy: `Termine alfabetico`,
definitionSortBy: `Alfabetico def.`,
ascSortBy: `Ascendente`,
descSortBy: `Discendente`,
featureSync: `Studia qualsiasi cosa, ovunque, in qualsiasi momento con le tue flashcard sincronizzate su tutti i tuoi dispositivi`,
featureSpacedrepetition: `Guarda i tuoi progressi complessivi e torna a praticare ciò di cui hai bisogno per esercitarti`,
featureNotifications: `Sottharged Charged il tuo apprendimento senza nemmeno aprire l'app con notifiche flessibili`,
featureFlashcards: `Flashcard automatici quando le mani o gli occhi sono occupati, ma hai ancora attenzione inutilizzata`,
featureQuiz: `Abbina, spiegano, ascolta o seleziona per praticare le tue flashcard`,
featureStats: `Ottieni una visione migliore delle tue carte e risultati e cerca su tutti i tuoi set di flashcard`,
featureImport: `Non memorizzeremo mai i dati di te e puoi esportare e importare facilmente tutti i tuoi dati`,
featurePrint: `Fai un po 'di apprendimento stampando le tue flashcard e fai -da -te il tuo impianto di studio`,
splashIntro: `Studia tutte le tue flashcard ovunque nel tuo ritmo e stile`,
selectSortOrder: `Ordinamento`,
selectSortProp: `Ordina proprietà`,
applyFilters: `Applica filtri`,
selectSetType: `Cosa vuoi praticare?`,
getStarted: `Iniziare`,
tapToUnarchive: `Tocca le carte che vuoi unarchive`,
untitled: `Senza titolo`,
sortHintNew: `Vedrai le carte che sono state create il tempo più lungo prima`,
sortHintDue: `vedrai le carte che sono state previste per le prime più lunghe`,
sortHintOther: `Vedrai carte che non sono state studiate prima`,
flashcardsWhen: `, quando le mani o gli occhi sono occupati, anche mentre ascolti musica / podcast`,
notificationsWhen: `, per quando sei in giro e desideri solo pezzi di studio rapidi`,
quizWhen: `, per quando puoi prestare piena attenzione per lo studio, per padroneggiare le tue carte`,
features: `Caratteristiche`,
ratings: `Giudizi`,
notificationDailyCatchUpBody: `Nuovo: __, dovuto: ___, studio: ____, appreso: _____, padroneggiato: ______`,
notificationDailyCatchUpTitle: `Cattura quotidiano`,
reviewedJN: `Recensione proprio ora`,
customUpdated: `Testo personalizzato aggiornato`,
customTextField: `Sinonimi, esempi, ecc.`,
field: `Campo`,
link: `Collegamento`,
backToParentCard: `Torna alla scheda madre`,
discard: `Scartare`,
failedImageLoad: `Impossibile caricare l'immagine, assicurati di essere connesso a Internet`,
printDIYLabel: `Fai -da -te la tua configurazione di studio basata su carta creativa, condividi con noi la tua creazione e ottieni presenti nell'app.`,
reviewGraphChart: `Frequenza di revisione`,
langNotSet: `Lingua non impostata`,
pronouncationLangInfo: `Per abilitare la pronuncia devi selezionare il linguaggio del termine e della definizione. Un segno dell'altoparlante apparirà accanto alle lingue se il tuo dispositivo supporta quella lingua`,
clearFilters: `Filtro pulito`,
subFreeUnlimited: `Studi illimitati, flashcard, pratiche, ricerca e sincronizzazione`,
customFields: `Campi personalizzati`,
subLinks: `Collegamenti della carta`,
subPrint: `Stampa / studyset`,
subNotifications: `Notifica prima di dover aprire l'app`,
subCardsStudysets: `Carte / studyset`,
subRevisionCycles: `Cicli di revisione personalizzati`,
subscriptionHEnd: `L'aggiornamento a Pro ci mostra che trovi prezioso il nostro duro lavoro e ci dà incoraggiamento e caffè per continuare a migliorare e creare nuove cose straordinarie.`,
subFree: `Libero`,
subPro: `Pro`,
guideSpacedRepetition: `In che modo i tipi di lavoro e pratica di ripetizione distanziati`,
guideSearch: `Ricerca e filtraggio`,
guideSync: `Abilita il backup e la sincronizzazione attraverso i tuoi dispositivi`,
guidePronunciation: `Abilita pronunce`,
guideImport: `Importazione di carte dalle fonti in uscita`,
guideAccess: `Chi ha accesso ai miei dati?`,
guideData: `Quali dati raccogliamo?`,
guideContact: `Hai bisogno di aiuto con qualcos'altro? Scrivici`,
arrowStrength: `Imposta quanto conosci questa carta`,
arrowImage: `Aggiungi immagini`,
arrowField: `Aggiungi ulteriori campi di testo personalizzati`,
arrowTag: `Tag allegati`,
arrowStar: `Mark come preferito`,
arrowLink: `Link ad altre carte`,
arrowGoal: `Impostare un obiettivo di revisione quotidiano per te stesso`,
arrowDue: `Parole di studio che dovrebbero essere riviste`,
arrowNew: `Carte di studio che non sono ancora state riviste`,
arrowMastered: `Se non hai carte dovute o nuove puoi rivedere le carte master per mantenerle padroneggiate`,
arrowImport: `Importa le tue flashcard esistenti`,
arrowNewCard: `Aggiungi una nuova flashcard`,
dropboxStep1: `1. Ottieni il codice di accesso da Dropbox accedendo`,
dropboxStep1Btn: `Accedi con Dropbox`,
dropboxStep2: `2. Immettere il codice di accesso di seguito`,
dropboxStep2Input: `Inserire il codice qui`,
dropboxStep3: `3. Avvia la sincronizzazione`,
alreadyLinked: `Già collegato, tocca per Unkk`,
selectCardsToLink: `Seleziona Cards to Link`,
unsupportedLangP: `Seleziona una lingua che supporta la pronuncia dalle impostazioni del set`,
links: `Link`,
emailUs: `Mandaci un email`,
whatsappUs: `WhatsApp US`,
printMinHeight: `Min. altezza della riga`,
exportType: `Tipo di file di esportazione`,
generateFileText: `Generare file`,
generatatingFile: `Generazione di file`,
verySmall: `Molto piccolo`,
small: `Piccolo`,
normal: `Normale`,
big: `Grande`,
veryBig: `Molto grande`,
repeatNTimes: `Ripeti __ volte`,
pause: `Pausa`,
for: `per`,
say: `Dire`,
defShort: `Def.`,
times: `volte`,
autoplayPreferences: `Imposta le preferenze automatiche`,
autoPlay1: `Pausa dopo la parola precedente`,
autoPlay2: `Numero di pronunce a termine`,
autoPlay3: `Pausa prima di rivelare la definizione`,
autoPlay4: `Numero di pronunce di definizione`,
autoPlay5: `Pausa prima di mostrare la parola successiva`,
autoPlay6: `Ripeti la stessa flashcard`,
startAutoPlay: `Avvia automatica automatica`,
autoPlayOffConfirm: `Spegni il automatico automatico per abilitare i controlli manuali`,
turnOff: `Spegni`,
keepPn: `Continua`,
foundIn: `Trovato in __`,
repeat: `ripetere`,
stop: `Fermare`,
listenInBreak: `Lo sapevate? Puoi ascoltare musica / podcast in pause`,
contextSearch: `Ricerca di contesto`,
contextSearchText: `Ottieni esempi di come __ usato in frasi diverse`,
transalteSearch: `Tradurre`,
translateSearchText: `Traduci in ___`,
synonymSearch: `Ricerca sinonimo`,
synonymSearchText: `Cerca sinonimi di __`,
selectToAdd: `Seleziona i risultati che si desidera aggiungere a questa scheda`,
addToCard: `Aggiungi selezionato alla carta`,
hideFromPractice: `Nascondersi in round`,
setLanguageRequired: `Seleziona la lingua dei termini e delle definizioni nei dettagli dello studio`,
fieldNeedsText: `Inserisci qualcosa in questo campo prima di cercare`,
possibleDupe: `Possibile duplicato`,
loadNextXCards: `Carica le carte successive __`,
repeatPractice: `Ripeti queste carte __`,
keepScreenOnInfo: `Potrebbe essere necessario regolare l'impostazione automatica del blocco automatico, per mantenere lo schermo acceso durante la automatica.`,
siteLoginH2: `Account SFM`,
siteLoginP: `Puoi utilizzare i tuoi account FlashCards Make Simple per condividere i tuoi flashcard con i tuoi amici, i tuoi studenti o l'intera comunità.`,
logOut: `Disconnettersi`,
logIn: `Accesso`,
createAccount: `Crea un nuovo account`,
signUp: `Iscriviti`,
username: `Nome utente`,
email: `E-mail`,
password: `Parola d'ordine`,
networkError: `Errore di rete`,
fillAllDetails: `Si prega di compilare tutti i dettagli`,
noUserWithDetails: `Nessun utente trovato con i dettagli inseriti`,
userAlreadyExists: `L'e -mail o il nome utente indicato esistono già`,
signUpOrLoginToCont: `Iscriviti o accedi per continuare?`,
atLeastOneCardToShare: `È richiesta almeno una carta per condividere`,
publishingStudyset: `Publishing StudySet`,
updatesDetected: `Aggiornamenti rilevati, vuoi procedere ad aggiornare i dati locali? (Eliminato: __, aggiornato: ___, nuovo: ____)`,
updatesApplied: `Aggiornamenti applicati`,
alreadyUpToDate: `Già aggiornato`,
practiceTypeArrow: `Scopri diversi modi di praticare`,
share: `Condividere`,
sharingModalIntro: `Condividi le tue flashcard in questo set con i tuoi amici, i tuoi studenti o l'intera comunità.`,
whatIsShared: `Ciò che è condiviso`,
whatIsNotShared: `Ciò che non è condiviso`,
whatIsSharedText: `Set Nome, Imposta Term Language, Definiton Language, tutte carte incluse con termini, definizioni, campi di testo personalizzati e immagini`,
whatIsNotSharedText: `Eventuali punti di forza della carta, stelle, collegamenti, tag e cronologia delle recensioni`,
checkForSharedUpdates: `Controlla gli aggiornamenti dal creatore`,
fetchUpdates: `Aggiornamenti di recupero`,
youSharedStudyset: `Hai condiviso questo studio`,
publishChanges: `Salva e pubblica modifiche`,
redeem: `Riscattare`,
noAds: `Nessuna pubblicità`,
dupeDetection: `Rilevamento duplicato`,
coffeeFeature: `Caffè, per aiutarci a sviluppare più funzionalità`,
shareLink: `Condividi il link`,
coffeeForUs: `Otterrai una licenza a vita solo per __, che dà a Emily 6 caffè, Dominik 3 caffè e caffè Russ 3, che ci alimentano per circa 39 ore per migliorare questo evento dell'app`,
sharingCards: `Condivisione di carte`,
published: `Pubblicato`,
alreadyHaveAccount: `Hai già un account?`,
notAlreadyHaveAccount: `Non hai ancora un conto?`,
startPractice: `Inizia le prove`,
selectQuizTypes: `Seleziona i tipi di quiz`,
correct: `Corretta`,
incorrect: `Errato`,
yes: `sì`,
no: `No`,
levelSilver: `Livello d'argento __`,
levelGold: `Livello d'oro __`,
levelPlatinum: `Livello di platino __`,
levelDiamond: `Livello di diamanti __`,
levelJade: `Livello di giada __`,
reviewsLeftGoal: `__ Recensioni per l'obiettivo quotidiano`,
dailyGoalAchieved: `Obiettivo quotidiano raggiunto`,
share: `Condividere`,
rateApp: `APP APP`,
allStats: `Tutte le statistiche`,
reviewTimeError: `Timeout dopo errore`,
reviewTimeCorrect: `Timeout dopo corretto`,
pronounceTermAfterReview: `Pronuncia il termine dopo la revisione`,
pronounceDefinitionAfterReview: `Pronunciare la definizione dopo la revisione`,
practice: `Pratica`,
notificationsScheduledInfo: `__ Sono state programmate notifiche, puoi chiudere l'app ora`,
wellDone: `Ben fatto`,
keepItUp: `Continuate così`,
youRock: `Sei forte`,
niceOne: `Ben fatto`,
lnSelect: `Seleziona la lingua`,
sampleData: `Nessuna recensione, che mostra i dati di esempio`,
reviewFreq: `Frequenza di revisione`,
selectPractice: `Pratica: seleziona`,
spellPractice: `Pratica: incantesimo`,
connectPractice: `Pratica: connettersi`,
languages: `Le lingue`,
languagesPairs: `Coppie di lingue`,
shareArrow: `Condividi il set con amici, studenti o tutta la comunità`,
cardsPerRound: `Carte / round`,
showAll: `Mostra tutto`,
supportedLangsVary: `Le lingue supportate variano`,
practiceWithoutSave: `Pratica non salvata`,
practiceWithoutSaveBody: `Non hai aggiunto questo studio alla tua collezione, vuoi aggiungerlo ora per salvare i tuoi progressi di studio?`,
saveSetNow: `Salva le carte alla tua raccolta`,
continueWithoutSaveSave: `Inizia le prove senza salvare`,
createdBy: `Creato da`,
setSavedToYourCollection: `Set di studio salvato alla tua collezione`,
accountBackupDisclaimer: `Si prega di notare che questo account può essere utilizzato solo per la condivisione di studi con gli altri e non può essere utilizzato per eseguire il backup o la sincronizzazione di studi o flashcard. Per sincronizzare e eseguire il backup di tutti i dati, utilizza Dropbox Sync`,
syncEnabled: `Sincronizzazione abilitata, recuperando i tuoi contenuti in corso`,
searchAllSets: `Set di studio di ricerca da altri utenti`,
anyLanguage: `Qualunque lingua`,
trendingIn: `Trend in`,
manualBackups: `Backup manuale`,
manualBackupCreate: `Crea backup manuale`,
confirmManualImport: `Sei sicuro di voler sostituire tutti i dati attuali con questo backup? Questo è raccomandato solo su nuovi dispositivi senza alcun dato`,
importFromManualBackup: `Importa dal backup`,
imgOfflineSets: `Immagini a scarico automatico per l'apprendimento offline`,
unsupportedDeviceCache: `Questa funzione è disponibile solo dall'app iOS o Android`,
shareChanges: `Condividi __ Cambiamenti`,
publiclySearchable: `Ricercabile dagli utenti`,
description: `Descrizione`,
restoreFromDropboxBackup: `Ripristina il backup di Dropbox`,
imageCacheStudysetSub: `[solo iOS e Android] Scarica immagine per lo studio offline`,
keywordsOrLangNeeded: `Devi inserire alcune parole chiave o una lingua`,
dropboxAlreadyLinked: `L'account Dropbox è già collegato`,
noSetUpdateAccess: `Non hai accesso per modificare questo set di studio.`,
confirmSetOwnerLogin: `Se sei sicuro di essere il proprietario, prova di nuovo ad accedere al tuo account.`,
uninitedRestriction: `Per salvare i tuoi progressi, prima devi aggiungere questo studio alla tua collezione`,
getStartedHere: `Get Started Here`,
downloadFromAppStore: `Download From AppStore`,
downloadFromGooglePlay: `Download From GooglePlay`,
consolidateStorageError: `Impossibile consolidare l'archiviazione`,
consolidateStorageDone: `Consolidati di archiviazione, consentire fino a un'ora per Dropbox per terminare la rimozione di vecchi file prima di accedere a un nuovo dispositivo.`,
consolidatingStorage: `Consoliding Storage ...`,
deleteAccount: `Eliminare l'account`,
consolidateStorageDescription: `Questa operazione reindelerà i file di backup, quindi la configurazione di un nuovo dispositivo sarà più veloce`,
consolidatingStorageConfirm: `Assicurati che tutte le modifiche abbiano già finito la sincronizzazione, non sincronizzare altri dispositivi mentre questo processo sta avvenendo. Vuoi continuare?`,
consolidateStorage: `Consolidare l'archiviazione`,


}